import "./WelcomeSection.css";
import { BottomSection } from "../../BottomSection/BottomSection";
import { TopSection } from "../../TopSection/TopSection";

export const WelcomeSection = ({isRegisterationTrue}) => {
  return (
    <>
      <div className="welcome-container">
        <TopSection />
        <div className="welcome-middle-section">
          <h2>Welcome!</h2>
          {
            isRegisterationTrue ? 
            <h5>Your account has been created successfully!</h5>
            :
            <h5>Your pin has been updated successfully!</h5>
          }
          <h6>You may close this window now</h6>
          <BottomSection />
        </div>
      </div>
    </>
  );
};
